// Heli Twister KV2008B
import React from "react";
import { Col, Row } from "reactstrap";
import {
   AccelerationTimeRow, ClockSetRow, CommonRows, CounterSetRow, CounterSwitchRow, DecelerationTimeRow,
   DelayedStartUpperRow, DelayedStopLowerRow, EncoderPulseRow, FantiRow, FirstTwistRow, FminLowerRow,
   HantiRow, LowerDeckRow, LowerSpindleSpeedRow, MaxStrokeCycleRow, MaxStrokeRow, MinStrokeRow, NoOfMaxStrokeRow,
   PackageTypeRow, ParameterSection, RadioButtonRow, RadioLabelCol, RingDownSpeedRow, RingStartPositionRow,
   RingUpSpeedRow, RollerCoefficientRow, RollerDiameterRow, RollerImpulseRow, RunTimeRow, ScrewPitchRow,
   SecondTwistRow, StrokeIncrementRow, TensionBallsSpindleRow, TensionBallsTopRow, TravelerSizeRow,
   UpperDeckRow, UpperSpindleSpeedRow
} from "./index";

export default function MachineHeliTwister() {
   return (
      <>
         <Row>
            <Col>
               <ClockSetRow />
               <ParameterSection titleProp={"Parameter Setting 1"} />
               <UpperSpindleSpeedRow />
               <LowerSpindleSpeedRow />
               <RingUpSpeedRow />
               <RingDownSpeedRow />
               <RingStartPositionRow />
               <MaxStrokeRow />
               <MinStrokeRow />
               <ParameterSection titleProp={"Parameter Setting 2"} />
               <PackageTypeRow />
               <StrokeIncrementRow />
               <FantiRow />
               <HantiRow />
               <MaxStrokeCycleRow />
               <NoOfMaxStrokeRow />
               <ParameterSection titleProp={"Parameter Setting 3"} />
               <FirstTwistRow />
               <SecondTwistRow />
               <CounterSwitchRow />
               <CounterSetRow />
               <TensionBallsTopRow />
               <TensionBallsSpindleRow />
            </Col>
            <Col>
               <RunTimeRow ColPromptSizeProp={6} ColValueSizeProp={6} />
               <ParameterSection titleProp={"Machine Setting 1"} />
               <ScrewPitchRow />
               <EncoderPulseRow />
               <UpperDeckRow />
               <LowerDeckRow />
               <RadioButtonRow promptRowSizeProp={6} valueRowSizeProp={6} titleProp={"Fault Warning"}>
                  <RadioLabelCol groupNameProp={"faultWarningGroup"} valueProp={"true"} onChangeProp={"faultWarning"} displayProp={"Alarm Output"} trueFalseProp />
                  <RadioLabelCol groupNameProp={"faultWarningGroup"} valueProp={"false"} onChangeProp={"faultWarning"} displayProp={"AutoStop"} trueFalseProp />
               </RadioButtonRow>

               <RadioButtonRow promptRowSizeProp={6} valueRowSizeProp={6} titleProp={"Speed Monitoring"}>
                  <RadioLabelCol groupNameProp={"speedMonitorinGroup"} valueProp={"true"} onChangeProp={"speedMonitoring"} displayProp={"Closed"} trueFalseProp />
                  <RadioLabelCol groupNameProp={"speedMonitorinGroup"} valueProp={"false"} onChangeProp={"speedMonitoring"} displayProp={"Active"} trueFalseProp />
               </RadioButtonRow>

               <RadioButtonRow promptRowSizeProp={6} valueRowSizeProp={6} titleProp={"Spindle Direction"}>
                  <RadioLabelCol groupNameProp={"spindleDirectionGroup"} valueProp={"S"} onChangeProp={"rotation"} displayProp={"S"} />
                  <RadioLabelCol groupNameProp={"spindleDirectionGroup"} valueProp={"Z"} onChangeProp={"rotation"} displayProp={"Z"} />
               </RadioButtonRow>

               <ParameterSection titleProp={"Machine Setting 2"} />
               <AccelerationTimeRow />
               <DecelerationTimeRow />
               <DelayedStartUpperRow />
               <DelayedStopLowerRow />
               <ParameterSection titleProp={"Machine Setting 3"} />
               <RollerDiameterRow />
               <RollerCoefficientRow />
               <RollerImpulseRow />
               <RadioButtonRow promptRowSizeProp={6} valueRowSizeProp={6} titleProp={"Pulse Rate"}>
                  <RadioLabelCol groupNameProp={"pulseRateGroup"} valueProp={0} onChangeProp={"pulseRate"} displayProp={"x1"} stringProp />{/* for some odd reason this one was an integer*/}
                  <RadioLabelCol groupNameProp={"pulseRateGroup"} valueProp={1} onChangeProp={"pulseRate"} displayProp={"x4"} stringProp />
               </RadioButtonRow>
               <RadioButtonRow promptRowSizeProp={6} valueRowSizeProp={6} titleProp={"Spinde Run when Reset"}>
                  <RadioLabelCol groupNameProp={"runResetGroup"} valueProp={"false"} onChangeProp={"runReset"} displayProp={"Off"} trueFalseProp />
                  <RadioLabelCol groupNameProp={"runResetGroup"} valueProp={"true"} onChangeProp={"runReset"} displayProp={"On"} trueFalseProp />
               </RadioButtonRow>
               <FminLowerRow />
            </Col>
         </Row>
         <TravelerSizeRow />
         <CommonRows />
      </>
   );
}
